import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const setInvalidResponse = invalidResponse => ({
  type: types.SET_INVALID_RESPONSE,
  invalidResponse,
});

export const setSliceInterval = (from, to, shouldFetch = true) => ({
  type: types.SET_SLICE_INTERVAL,
  from,
  to,
  shouldFetch,
});

export const setBirdChartState = state => ({
  type: types.SET_BIRD_CHART_STATE,
  state,
});

export const setZoomRange = (zoomStart, zoomEnd) => ({
  type: types.SET_ZOOM_RANGE,
  zoomStart,
  zoomEnd,
});

export const setBrushRange = (brushStart, brushEnd) => ({
  type: types.SET_BRUSH_RANGE,
  brushStart,
  brushEnd,
});


export const resetSliceInterval = () => ({
  type: types.RESET_SLICE_INTERVAL,
});

export const fetching = () => ({
  type: types.FETCHING,
});

export const fetchingSuccess = sliceResponse => ({
  type: types.FETCHING_SUCCESS,
  sliceResponse,
});

export const fetchingFails = (errorCode, errorMsg) => ({
  type: types.FETCHING_FAILS,
  errorCode,
  errorMsg,
});

export const fetchingSlice = () => ({
  type: types.FETCHING_SLICE,
});

export const fetchingSliceSuccess = response => ({
  type: types.FETCHING_SUCCESS,
  response,
});

export const fetchingSliceFails = (errorCode, errorMsg) => ({
  type: types.FETCHING_FAILS,
  errorCode,
  errorMsg,
});

export const resetResponse = () => ({
  type: types.RESET_RESPONSE,
});
